import React from "react";
import { useFieldArray } from "react-hook-form";
import "../constants/constants.css";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import "./Websites.css";

export default function Fields({ control, register, index }) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `previewPages.[${index}].websites`,
  });

  return (
    <div className="form-wrapper-sites">
      <ul>
        {fields.map((item, indexSite) => {
          return (
            <li key={item.id}>
              <div className="form-container-sites">
                <div className="inner-input-sites-form-container">
                  <InputFieldFormArray
                    label="Site "
                    fieldRef={register(
                      `previewPages[${index}].websites[${indexSite}].site`,
                      {
                        required: false,
                      }
                    )}
                    name={`previewPages[${index}].websites[${indexSite}].site`}
                    key={item.id}
                  />

                  <button
                    className="sites-button delete-button"
                    type="button"
                    onClick={() => {
                      remove(indexSite);
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      <section>
        <button
          className="append-button"
          type="button"
          onClick={() => {
            append();
          }}
        >
          Add site
        </button>
      </section>
    </div>
  );
}
